
import { RutaLocal } from '../componentes/funcionesEspeciales'
import Logo from '../media/img/logo_principal.png'
function TerminosCondiciones() {

    return (<>
        <div className='container py-3' style={{ textAlign: "justify" }}>

            <h2>INFORMACIÓN SOBRE TÉRMINOS Y CONDICIONES</h2>
            <br />
            <h5>
                Registro y Cuentas
            </h5>
            <p>
                Para realizar pedidos, los usuarios deben registrarse en el sitio web proporcionando información veraz y completa.
                Los usuarios son responsables de mantener la confidencialidad de su cuenta y contraseña, así como de todas las actividades que ocurran bajo su cuenta.
            </p>

            <h5>
                Pedidos y Entregas
            </h5>
            <p>
                Los pedidos se pueden realizar a través de nuestro sitio web siguiendo las instrucciones proporcionadas.
                Hacemos todo lo posible para garantizar que los productos se entreguen dentro del tiempo estimado. Sin embargo, los tiempos de entrega pueden variar debido a factores fuera de nuestro control.
                En caso de cualquier problema con la entrega, comuníquese con nuestro servicio al cliente para resolver el asunto.
            </p>
            <h5>
                Precios y Pagos
            </h5>
            <p>
                Los precios están sujetos a cambios sin previo aviso, pero los cambios no afectarán a los pedidos ya confirmados.
                Los pagos se pueden realizar mediante los métodos de pago aceptados en nuestro sitio web.
            </p>
            <h5>
                Cancelaciones y Reembolsos
            </h5>
            <p>
                Los pedidos pueden ser cancelados por el usuario antes de que hayan sido procesados para la entrega. Una vez que un pedido ha sido procesado, no se puede cancelar.

                En caso de que un producto entregado no cumpla con los estándares de calidad, los usuarios pueden comunicarse con nuestro servicio al cliente y la empresa evaluará lo sucedido.
            </p>
            <h5>
                Propiedad Intelectual
            </h5>
            <p>
                Todos los contenidos del sitio web, incluidos textos, gráficos, logotipos, imágenes y software, son propiedad de EL GALPON POLLOS Y PARRILLAS o de sus licenciantes y están protegidos por leyes de propiedad intelectual.
                Los usuarios no pueden reproducir, distribuir, modificar o crear trabajos derivados de cualquier contenido del sitio web sin nuestro consentimiento previo por escrito.
            </p>
        </div>
    </>)
}
export default TerminosCondiciones;